import videoPreview from "./videoPreview/videoPreview";
import videoPreviewExpand from "./videoPreview/videoPreviewExpand";
import videoBack from "./videoPreview/videoBack";

import { version } from '../package.json';

const components = [videoPreview, videoPreviewExpand, videoBack];

const install = function(Vue) {
  if (install.installed) return;
  components.map(component => Vue.component(component.name, component));
};

// 版本Tag
if (typeof window !== 'undefined') {
  window.VideoPreview = videoPreview;
  window.VideoPreview.VERSION = version;
  var r = ["color: #fff", "border-top-left-radius:3px", "border-bottom-left-radius:3px", "background-color: #708090", "padding: 5px"].join(";")
  , i = ["color: #fff", "border-top-right-radius:3px", "border-bottom-right-radius:3px", "background-color: #808000", "padding: 5px"].join(";");

  console.log("%cvideoPreviewVersion %c".concat(version), r, i)}

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
export default {
  install,
  videoPreview,
  videoPreviewExpand,
  videoBack
};
// 按需引入
export { videoPreview, videoPreviewExpand, videoBack };
